import * as React from "react";

const Links : React.FC = () => {
    return (
        <React.Fragment>
            <h2>関連病院</h2>
            <ul className={"links"}>
                <li><a href={"https://general.tane.or.jp/"} target={"_blank"}>多根総合病院</a></li>
                <li><a href={"https://minato.jcho.go.jp/"} target={"_blank"}>みなと中央病院</a></li>
                <li><a href={"http://www.osaka-centralhp.jp/"} target={"_blank"}>大阪中央病院</a></li>
                <li><a href={"https://www.kitano-hp.or.jp/"} target={"_blank"}>北野病院</a></li>
                <li><a href={"https://oici.jp/"} target={"_blank"}>大阪国際がんセンター</a></li>
                <li><a href={"https://www.nissay-hp.or.jp/"} target={"_blank"}>日本生命病院</a></li>
                <li><a href={"https://osaka.jcho.go.jp/"} target={"_blank"}>JCHO大阪病院</a></li>
                <li><a href={"https://hospital.ompu.ac.jp/"} target={"_blank"}>大阪医科薬科大学病院</a></li>
                <li><a href={"https://www.naramed-u.ac.jp/"} target={"_blank"}>奈良県立医科大学</a></li>
            </ul>
            <h2>関連学会</h2>
            <ul className={"links"}>
                <li><a href={"http://zinjection.net/"} target={"_blank"}>内痔核治療法研究会</a></li>
                <li><a href={"http://www.jssoc.or.jp/"} target={"_blank"}>日本外科学会</a></li>
                <li><a href={"https://www.coloproctology.gr.jp/"} target={"_blank"}>日本大腸肛門病学会</a></li>
                <li><a href={"https://www.jges.net/"} target={"_blank"}>日本消化器内視鏡学会</a></li>
                <li><a href={"https://www.jsgs.or.jp/"} target={"_blank"}>日本消化器外科学会</a></li>
                <li><a href={"http://plaza.umin.ac.jp/~rinkoken/"} target={"_blank"}>臨床肛門病学会</a></li>
            </ul>
            <h2>医師会</h2>
            <ul className={"links"}>
                <li><a href={"http://www.minato-med.or.jp/"} target={"_blank"}>港区医師会</a></li>
                <li><a href={"https://www.osaka.med.or.jp/"} target={"_blank"}>大阪府医師会</a></li>
                <li><a href={"https://www.med.or.jp/"} target={"_blank"}>日本医師会</a></li>
            </ul>
        </React.Fragment>
    );
}

export default Links;
